import React from 'react';

import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from '@mui/material';

interface Props {
  onChange?: any;
  defaultValue?: boolean;
  disableCancellation?: boolean;
}

export default function MarkCancelled({ onChange, defaultValue, disableCancellation = false }: Props) {
  return (
    <FormControl required>
      <FormLabel
        sx={{
          fontWeight: 'bold',
        }}
      >
        Should the booking be cancelled?
      </FormLabel>
      <RadioGroup
        name="markCancelled"
        row
        onChange={onChange ? onChange : undefined}
        defaultValue={disableCancellation ? false : defaultValue}
      >
        <FormControlLabel
          data-cy="mark-cancelled-true"
          key="should-booking-be-cancelled-yes"
          value
          control={<Radio disabled={disableCancellation} required />}
          label="Yes"
        />
        <FormControlLabel
          data-cy="mark-cancelled-false"
          key="should-booking-be-cancelled-no"
          value={false}
          control={<Radio />}
          label="No"
        />
      </RadioGroup>
      {disableCancellation && (
        <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
          ⚠️ Cancellation is blocked because there are active optional experiences on this tour.
        </Typography>
      )}
    </FormControl>
  );
}
